import Splash from 'component/LaunchSplash'
import {
  SecondButton,
  MaintenancePageModal,
  MaintenancePageWrapper,
  PageContent,
  PageContentLine,
  PageFooter,
  PageTitle,
  ThirdButton,
  PageContentLineWrapper,
} from './Styled'
import React, { useCallback, useMemo, useState } from 'react'
import { FullWidthPrimaryButton } from 'commonStyledComponents'
import { useSelector } from 'react-redux'
import { selectFullPageError } from 'redux/selector/app'
import { getMetadataJSONWithUrlWithCache } from 'utils/id-util/update-util'
import { getVisitorId } from 'redux/saga/user'
import CustomerServiceModal from 'component/CustomerServiceModal'
import PlaceboChooserModal from './PlaceboChooserModal'
import MobileConfigUpdateFlow from 'component/MobileConfigUpdate/components/MobileConfigUpdateFlow'
import { checkInWebview } from 'hooks/useWebViewHandler'
import { PRELOAD_DATA_LOCAL_STORAGE_KEY } from 'constant/common'

export default function FullPageError() {
  const info = useSelector(selectFullPageError)
  const title = info?.title || '发生错误'
  const lines = useMemo(() => (info?.message ? info?.message.split('\n') : ['连线失败']), [info])
  const isInWebview = checkInWebview()
  const showButton = info?.hideButton !== true

  const version = useMemo(() => {
    return process.env.REACT_APP_VERSION + '.' + process.env.REACT_APP_GIT_SHA
  }, [])

  const handleRetry = useCallback(() => {
    window.location.replace('/')
  }, [])

  // const landingUrl = useMemo(() => {
  //   if (process.env.REACT_APP_LANDING_PAGE_HOST) return 'https://' + process.env.REACT_APP_LANDING_PAGE_HOST
  // }, [])

  // const handleToLanding = useCallback(() => {
  //   if (process.env.REACT_APP_LANDING_PAGE_HOST) window.open(landingUrl, '_blank')
  // }, [landingUrl])

  const [contactOpen, setContactOpen] = useState(false)
  const [contactList, setContactList] = useState<any[]>([])

  const handleContact = async () => {
    try {
      const config = await getMetadataJSONWithUrlWithCache(
        process.env.REACT_APP_PRELOAD_PATH as string,
        PRELOAD_DATA_LOCAL_STORAGE_KEY
      )
      // const selectedUrl = config.help_desks[Math.floor(Math.random() * config.help_desks.length)]

      // const url = new URL(selectedUrl)
      // url.searchParams.set('id', getVisitorId())
      // window.location.href = url.toString()
      setContactList(config.help_desks.map((url: string, i: number) => ({ id: i, url })))
      setContactOpen(true)
    } catch (err) {
      setContactOpen(true)
    }
  }

  const [placeboChooserOpen, setPlaceboChooserOpen] = useState(false)

  const [updateFlowOpened, setUpdateFlowOpened] = useState(false)

  return (
    <React.Fragment>
      <Splash></Splash>
      <MaintenancePageWrapper>
        <MaintenancePageModal>
          <PageContent>
            <PageTitle>{title}</PageTitle>
            <PageContentLineWrapper>
              {lines.map((m, i) => (
                <PageContentLine key={i}>{m}</PageContentLine>
              ))}
            </PageContentLineWrapper>
          </PageContent>
          {showButton && (
            <FullWidthPrimaryButton onClick={() => setPlaceboChooserOpen(true)}>切换线路</FullWidthPrimaryButton>
          )}
          {!isInWebview ? (
            <>
              {showButton && <SecondButton onClick={() => setUpdateFlowOpened(true)}>下载最新线路版本</SecondButton>}
              {showButton && <ThirdButton onClick={handleContact}>联系客服</ThirdButton>}
            </>
          ) : (
            showButton && <SecondButton onClick={handleContact}>联系客服</SecondButton>
          )}
        </MaintenancePageModal>
        <PageFooter>
          {/* <PageContentLine>{landingUrl && <span onClick={handleToLanding}>前往官网</span>}</PageContentLine> */}
          <PageContentLine>{version}</PageContentLine>
        </PageFooter>
      </MaintenancePageWrapper>
      <CustomerServiceModal
        isOpen={contactOpen}
        list={contactList}
        onClose={() => setContactOpen(false)}
        onClick={(item: any) => {
          const url = new URL(item.url)
          url.searchParams.set('id', getVisitorId())
          // window.location.href = url.toString()
          window.open(url.toString(), '_blank')
        }}
        overlayStyle={{
          zIndex: 'calc(var(--layer-fullpage-modal) + 2)',
        }}
      />
      <PlaceboChooserModal
        isOpen={placeboChooserOpen}
        onClose={() => setPlaceboChooserOpen(false)}
        onClickOption={handleRetry}
      />
      <MobileConfigUpdateFlow isOpen={updateFlowOpened} onClose={() => setUpdateFlowOpened(false)} />
    </React.Fragment>
  )
}
